var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExtendeView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47464_90205)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.6667C0 13.9303 0.44771 13.3333 1 13.3333H6C6.5523 13.3333 7 13.9303 7 14.6667C7 15.4031 6.5523 16 6 16H1C0.44771 16 0 15.4031 0 14.6667ZM0 1.33333C0 0.596947 0.44771 0 1 0H6C6.5523 0 7 0.596947 7 1.33333C7 2.06971 6.5523 2.66667 6 2.66667H1C0.44771 2.66667 0 2.06971 0 1.33333ZM0 8C0 7.26363 0.44771 6.66667 1 6.66667H6C6.5523 6.66667 7 7.26363 7 8C7 8.7364 6.5523 9.33333 6 9.33333H1C0.44771 9.33333 0 8.7364 0 8Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 14.6667C9 13.9303 9.44771 13.3333 10 13.3333H15C15.5523 13.3333 16 13.9303 16 14.6667C16 15.4031 15.5523 16 15 16H10C9.44771 16 9 15.4031 9 14.6667ZM9 1.33333C9 0.596947 9.44771 0 10 0H15C15.5523 0 16 0.596947 16 1.33333C16 2.06971 15.5523 2.66667 15 2.66667H10C9.44771 2.66667 9 2.06971 9 1.33333ZM9 8C9 7.26363 9.44771 6.66667 10 6.66667H15C15.5523 6.66667 16 7.26363 16 8C16 8.7364 15.5523 9.33333 15 9.33333H10C9.44771 9.33333 9 8.7364 9 8Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47464_90205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "current"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtendeView);
export default __webpack_public_path__ + "static/media/ExtendeView.77712d48b67cc09b88b94c95ca4bd93f.svg";
export { ForwardRef as ReactComponent };